import {
    createContext,
    useState,
    useContext,
    useEffect,
    useCallback,
    useRef,
} from 'react';

import { LiveGames } from './LiveGamesData';
import Cookies from 'js-cookie';
import { apiJSONURL, apiUrlNew, promoURL } from '../../App';
import { encrypt } from './CryptoUtil';
const GlobalContext = createContext();

const encryptData = (data) => {
    const salt = Math.random().toString(36).substring(2, 10);
    return salt + ':' + btoa(salt + data);
};

const removeBreaker = (value) => {
    return typeof value === 'string'
        ? value.replace(/<br\s*\/?>/gi, ' ')
        : value;
};

const decryptData = (encrypted) => {
    if (!encrypted) return '';
    const parts = encrypted.split(':');
    if (parts.length !== 2) return '';
    const salt = parts[0];
    const encoded = parts[1];
    try {
        const combined = atob(encoded);
        if (combined.startsWith(salt)) {
            return combined.slice(salt.length);
        }
    } catch (error) {
        return '';
    }
    return '';
};

export const encryptUsername = (username) => encryptData(username);
export const decryptUsername = (encrypted) => decryptData(encrypted);
export const encryptPassword = (password) => encryptData(password);
export const decryptPassword = (encrypted) => decryptData(encrypted);
export const GlobalProvider = ({ children }) => {
    const [username, setUsername] = useState(null);
    const [customUsername, setCustomUsername] = useState(null);
    const [walletBalance, setWalletBalance] = useState(null);
    const [currentJiliStage, setCurrentJiliStage] = useState(null);
    // const [mobile, setMobile] = useState(null)
    const [password, setPassword] = useState(null);
    const [sg8Wallet, setSg8Wallet] = useState(null);
    const [ascWallet, setAscWallet] = useState(null);
    const [goldenfWallet, setGoldenfWallet] = useState(null);
    const [sbsboWallet, setSbsboWallet] = useState(null);
    const [rtgWallet, setRtgboWallet] = useState(null);
    const [showEasterEgg, setShowEasterEgg] = useState(false);
    const [vipDetails, setVipDetails] = useState({
        vipName: 'Standard',
        vipLevel: '1',
        vipImage: '/images/icon/vip/emerald.webp',
    });
    const [playerDetails, setPlayerDetails] = useState({});
    const [transactionReport, setTransactionReport] = useState([]);
    const [userLoading, setUserLoading] = useState(false);
    const [rollover, setRollover] = useState(null);
    const [showMysteryFridayBtn, setShowMysteryFridayBtn] = useState(false);
    const [showPrompt, setShowPrompt] = useState(false);
    const [message, setMessage] = useState(null);
    const [showRecoveryBonusPrompt, setShowRecoveryBonusPrompt] =
        useState(false);
    const [ag, setAg] = useState(null);
    const [triggerFetch, setTriggerFetch] = useState(false);
    const [loadingBalance, setLoadingBalance] = useState(false);
    const [messages, setMessages] = useState([]);
    const [messageReload, setMessageReload] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [jiliFortuneRushInfo, setJiliFortuneRushInfo] = useState(null);
    const [jiliFortuneRushLoading, setJiliFortuneRushLoading] = useState(false);

    // JILI Fortune Rush Leaderboard
    const [jiliFortuneRushLeaderboard, setJiliFortuneRushLeaderboard] =
        useState([]);
    const [jiliFortuneRushMinimumTurnover, setJiliFortuneRushMinimumTurnover] =
        useState(0);

    const [jiliFortuneRushWeek, setJiliFortuneRushWeek] = useState(0);
    const [jiliFortuneRushSpinWeek, setJiliFortuneRushSpinWeek] = useState(0);
    const [
        jiliFortuneRushLeaderboardLoading,
        setJiliFortuneRushLeaderboardLoading,
    ] = useState(false);

    const [
        jiliFortuneRushLeaderboardError,
        setJiliFortuneRushLeaderboardError,
    ] = useState('');

    const fetchJiliFortuneRushInfo = useCallback(
        async (user = username) => {
            if (!user) {
                setJiliFortuneRushInfo(null);
                return null;
            }

            try {
                setJiliFortuneRushLoading(true);

                const encryptedUsername = await encrypt(user);

                const response = await fetch(promoURL, {
                    method: 'POST',
                    headers: {
                        'Content-Type':
                            'application/x-www-form-urlencoded;charset=UTF-8',
                    },
                    body: new URLSearchParams({
                        cmd: 'getJiliFortuneRushInfo',
                        u: encryptedUsername,
                    }).toString(),
                });

                if (!response.ok) {
                    throw new Error(
                        `Failed to fetch JILI Fortune Rush: ${response.status}`
                    );
                }

                const data = await response.json();

                const currentMilestone =
                    data?.spinFuel?.currentMilestone ??
                    data?.currentMilestone ??
                    null;

                const milestoneRewards = {};

                Object.entries(data || {}).forEach(([key, value]) => {
                    const match = key.match(/^(\d{8})-(M\d+)$/i);

                    if (!match) return;

                    const [, date, milestoneRaw] = match;

                    const milestone = milestoneRaw.toUpperCase();

                    const existing = milestoneRewards[milestone];

                    /*
                     * Keep the latest date for each milestone.
                     *
                     * YYYYMMDD can safely be compared as a number/string.
                     */
                    if (!existing || Number(date) > Number(existing.date)) {
                        milestoneRewards[milestone] = {
                            ...(value || {}),
                            date,
                            apiKey: key,
                        };
                    }
                });

                const milestoneClaimableRewards = currentMilestone
                    ? (milestoneRewards?.[currentMilestone]?.claimableRewards ??
                      null)
                    : null;

                const normalizedData = {
                    ...data,

                    // Daily
                    depositAmount: Number(data?.daily?.deposit ?? 0),
                    turnover: Number(
                        data?.daily?.turnover ?? data?.spinFuel?.turnover ?? 0
                    ),

                    tier: Number(data?.daily?.tier ?? 1),
                    raffleTicketsEarnedToday: Number(
                        data?.daily?.raffleTicketsEarnedToday ?? 0
                    ),

                    currentWeek: Number(data?.currentWeek ?? 0),

                    // Raffle
                    ticket: Number(data?.raffle?.totalTickets ?? 0),
                    totalTickets: Number(data?.raffle?.totalTickets ?? 0),

                    // Spin Fuel
                    currentMilestone: data?.spinFuel?.currentMilestone ?? null,

                    claimableRewards:
                        milestoneClaimableRewards ??
                        data?.spinFuel?.claimableRewards ??
                        data?.claimableRewards ??
                        null,

                    nextMilestone: data?.spinFuel?.nextMilestone ?? null,

                    nextTarget: Number(data?.spinFuel?.nextTarget ?? 0),

                    spinFuelTurnover: Number(data?.spinFuel?.turnover ?? 0),

                    milestoneRewards,

                    // Promo
                    promoStatus:
                        data?.promoStatus ?? data?.daily?.promoStatus ?? null,

                    currentEvent: data?.currentEvent ?? null,
                };

                console.log(
                    'Normalized JILI Fortune Rush Info:',
                    normalizedData
                );

                setJiliFortuneRushInfo(normalizedData);

                return normalizedData;
            } catch (error) {
                console.error('Error fetching JILI Fortune Rush:', error);

                setJiliFortuneRushInfo(null);

                return null;
            } finally {
                setJiliFortuneRushLoading(false);
            }
        },
        [username]
    );

    const getJiliFortuneRushLeaderboard = useCallback(async () => {
        try {
            setJiliFortuneRushLeaderboardLoading(true);
            setJiliFortuneRushLeaderboardError('');

            const response = await fetch(promoURL, {
                method: 'POST',
                headers: {
                    'Content-Type':
                        'application/x-www-form-urlencoded;charset=UTF-8',
                },
                body: new URLSearchParams({
                    cmd: 'getJiliFortuneRushLeaderboard',
                }).toString(),
            });

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch JILI Fortune Rush Leaderboard: ${response.status}`
                );
            }

            const data = await response.json();

            const leaderboardData = data?.leaderboard || {};

            const currentUsername = String(username || '')
                .trim()
                .toLowerCase();
            const formattedLeaderboard = Object.entries(leaderboardData)
                .map(([rank, value]) => {
                    const [
                        maskedUsername = '',
                        turnover = '0',
                        actualUsername = '',
                    ] = String(value).split('|');

                    const apiUsername = String(actualUsername)
                        .trim()
                        .toLowerCase();

                    return {
                        rank: Number(rank),
                        player: maskedUsername,
                        score: Number(turnover) || 0,
                        isYou:
                            currentUsername !== '' &&
                            currentUsername === apiUsername,
                    };
                })
                .sort((a, b) => a.rank - b.rank);

            const minimumTurnover = Number(data?.minimumTurnover) || 0;
            const week = Number(data?.week) || 0;

            setJiliFortuneRushLeaderboard(formattedLeaderboard);
            setJiliFortuneRushMinimumTurnover(minimumTurnover);
            setJiliFortuneRushWeek(week);

            return {
                leaderboard: formattedLeaderboard,
                minimumTurnover,
                week,
            };
        } catch (error) {
            console.error(
                'Error fetching JILI Fortune Rush Leaderboard:',
                error
            );

            setJiliFortuneRushLeaderboardError('Unable to load leaderboard.');

            setJiliFortuneRushLeaderboard([]);

            return null;
        } finally {
            setJiliFortuneRushLeaderboardLoading(false);
        }
    }, [username]);

    useEffect(() => {
        if (!isLoggedIn) {
            setJiliFortuneRushLeaderboard([]);
            setJiliFortuneRushMinimumTurnover(0);
            setJiliFortuneRushWeek(0);
            setJiliFortuneRushLeaderboardError('');
            return;
        }

        // Fetch immediately
        getJiliFortuneRushLeaderboard();

        // Refresh every 10 minutes
        const intervalId = setInterval(
            () => {
                getJiliFortuneRushLeaderboard();
            },
            10 * 60 * 1000
        );

        return () => {
            clearInterval(intervalId);
        };
    }, [isLoggedIn, getJiliFortuneRushLeaderboard]);

    useEffect(() => {
        if (!isLoggedIn || !username) {
            setJiliFortuneRushInfo(null);
            return;
        }

        fetchJiliFortuneRushInfo(username);
    }, [isLoggedIn, username, fetchJiliFortuneRushInfo]);

    const updateCurrentJiliStage = (stage) => {
        setCurrentJiliStage(stage);

        if (stage && username) {
            localStorage.setItem(
                `currentJiliQuestStage_${username}`,
                JSON.stringify(stage)
            );
        }
    };

    // useEffect(() => {
    //     if (!username) {
    //         setCurrentJiliStage(null);
    //         return;
    //     }

    //     const saved = localStorage.getItem(`currentJiliQuestStage_${username}`);

    //     if (!saved) {
    //         setCurrentJiliStage(null);
    //         return;
    //     }

    //     try {
    //         setCurrentJiliStage(JSON.parse(saved));
    //     } catch (error) {
    //         console.error('[JILI] Failed to restore current stage:', error);

    //         setCurrentJiliStage(null);
    //     }
    // }, [username]);

    useEffect(() => {
        const loggedInState = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(loggedInState);
    }, []);

    const goBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = '/';
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const cookieAg = Cookies.get('ag');
        const urlAg = urlParams.get('ag');
        const agValue = cookieAg ? cookieAg : urlAg;

        if (agValue) {
            Cookies.set('ag', agValue, { expires: 1 });
            setAg(agValue);
        }
    }, []);

    const parseTransactionArray = (arr) => ({
        dateTime: removeBreaker(arr[0]),
        transactionSummary: `${removeBreaker(arr[1])} - ${removeBreaker(arr[2])}`,
        transacId: removeBreaker(arr[1]),
        vendor: removeBreaker(arr[3]),
        paymentMethod: removeBreaker(arr[4]),
        amount: removeBreaker(arr[5]),
        status: removeBreaker(arr[6]),
        userId: removeBreaker(arr[8]),
        bonus: removeBreaker(arr[9]),
        fee: removeBreaker(arr[10]),
    });

    const fetchWalletBalance = useCallback(
        async (user) => {
            if (!user) return 'N/A';
            try {
                setLoadingBalance(true);

                const encryptedUsername = await encrypt(user);

                const response = await fetch(
                    `${apiJSONURL}?cmd=getBalance&u=${encryptedUsername}`
                );
                if (!response.ok)
                    throw new Error('Failed to fetch wallet balance.');
                const data = await response.json();

                const balanceNumber = parseFloat(data.balance) || 0;
                const sg8Number = parseFloat(data.SG8WALLET) || 0;
                const ascBalance = parseFloat(data.ASC) || 0;
                const goldenfBalance = parseFloat(data.GOLDENF) || 0;
                const sbsboBalance = parseFloat(data.SBSBO) || 0;
                const rtgBalance = parseFloat(data.RTG) || 0;

                return {
                    balance: balanceNumber.toLocaleString(),
                    sg8: sg8Number.toLocaleString(),
                    asc: ascBalance.toLocaleString(),
                    goldenf: goldenfBalance.toLocaleString(),
                    sbsbo: sbsboBalance.toLocaleString(),
                    rtg: rtgBalance.toLocaleString(),
                    rawData: data,
                };
            } catch (error) {
                console.error('Error fetching wallet balance:', error);
                return 'N/A';
            } finally {
                setLoadingBalance(false);
            }
        },
        [apiJSONURL, triggerFetch]
    );

    const handleReturnWallet = async (username) => {
        const params = new URLSearchParams({
            cmd: 'withdrawFromAll',
            u: username,
        });

        try {
            await fetch(`${apiJSONURL}?${params}`);
            const { balance, sg8, asc, goldenf, sbsbo, rtg } =
                await fetchWalletBalance(username);

            // ✅ Update state so UI refreshes immediately
            setWalletBalance(balance);
            setSg8Wallet(sg8);
            setAscWallet(asc);
            setGoldenfWallet(goldenf);
            setSbsboWallet(sbsbo);
            setRtgboWallet(rtg);
        } catch (error) {
            console.error(
                'There was a problem with the fetch operation:',
                error
            );
        }
    };

    const formatVipName = (name) => {
        if (!name) return '';
        return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    };

    const refreshWalletBalances = useCallback(
        async (user) => {
            if (!user) return;

            const result = await fetchWalletBalance(user);
            if (!result || result === 'N/A') return;

            const { balance, sg8, asc, goldenf, sbsbo, rtg } = result;

            setWalletBalance(balance);
            setSg8Wallet(sg8);
            setAscWallet(asc);
            setGoldenfWallet(goldenf);
            setSbsboWallet(sbsbo);
            setRtgboWallet(rtg);
        },
        [fetchWalletBalance]
    );

    const applyWalletBalances = useCallback((data) => {
        setWalletBalance((parseFloat(data.balance) || 0).toLocaleString());
        setSg8Wallet((parseFloat(data.SG8WALLET) || 0).toLocaleString());
        setAscWallet((parseFloat(data.ASC) || 0).toLocaleString());
        setGoldenfWallet((parseFloat(data.GOLDENF) || 0).toLocaleString());
        setSbsboWallet((parseFloat(data.SBSBO) || 0).toLocaleString());
        setRtgboWallet((parseFloat(data.RTG) || 0).toLocaleString());
    }, []);

    const fetchVipDetails = useCallback(
        async (user) => {
            if (!user)
                return {
                    vipName: 'Standard',
                    vipLevel: '1',
                    vipImage: '/images/icon/vip/placeholder.webp',
                    vipDepositToNextLevel: 0,
                    vipDepositToRetain: 0,
                    vipTurnoverToNextLevel: 0,
                    vipTurnoverToRetain: 0,
                    vipTotalDeposit: 0,
                    vipTotalPayout: 0,
                    vipTotalTurnover: 0,
                    vipTotalWinloss: 0,
                };
            try {
                const encryptedUsername = await encrypt(user);
                const response = await fetch(
                    `${apiJSONURL}?cmd=getVIP&u=${encryptedUsername}`
                );
                if (!response.ok)
                    throw new Error('Failed to fetch VIP details.');
                const data = await response.json();
                const vipLevel = data.vipLevel || '1';
                const vipImages = {
                    1: '/images/icon/vip/emerald-icon.webp',
                    2: '/images/icon/vip/sapphire-icon.webp',
                    3: '/images/icon/vip/ruby-icon.webp',
                    4: '/images/icon/vip/diamond-icon.webp',
                    5: '/images/icon/vip/alexandrite-icon.webp',
                };
                return {
                    vipName: formatVipName(data.vipName || 'Standard'),
                    vipLevel,
                    vipImage: vipImages[vipLevel] || vipImages[1],
                    vipDepositToNextLevel: data.vipDepositToNextLevel || 0,
                    vipDepositToRetain: data.vipDepositToRetain || 0,
                    vipTurnoverToNextLevel: data.vipTurnoverToNextLevel || 0,
                    vipTurnoverToRetain: data.vipTurnoverToRetain || 0,
                    vipTotalDeposit: data.vipTotalDeposit || 0,
                    vipTotalPayout: data.vipTotalPayout || 0,
                    vipTotalTurnover: data.vipTotalTurnover || 0,
                    vipTotalWinloss: data.vipTotalWinloss || 0,
                };
            } catch (error) {
                console.error('Error fetching VIP details:', error);
                return {
                    vipName: 'Standard',
                    vipLevel: '1',
                    vipImage: '/images/icon/vip/emerald.webp',
                    vipDepositToNextLevel: 0,
                    vipDepositToRetain: 0,
                    vipTurnoverToNextLevel: 0,
                    vipTurnoverToRetain: 0,
                    vipTotalDeposit: 0,
                    vipTotalPayout: 0,
                    vipTotalTurnover: 0,
                    vipTotalWinloss: 0,
                };
            }
        },
        [apiJSONURL]
    );
    function base64ToArrayBuffer(base64) {
        const binary = atob(base64);
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes.buffer;
    }

    const decrypt = async (encryptedBase64, key) => {
        try {
            const encryptedBytes = base64ToArrayBuffer(encryptedBase64);

            const iv = encryptedBytes.slice(0, 16);
            const ciphertext = encryptedBytes.slice(16);

            const cryptoKey = await window.crypto.subtle.importKey(
                'raw',
                new TextEncoder().encode(key),
                { name: 'AES-CBC' },
                false,
                ['decrypt']
            );

            const decryptedBuffer = await window.crypto.subtle.decrypt(
                { name: 'AES-CBC', iv: new Uint8Array(iv) },
                cryptoKey,
                ciphertext
            );

            return new TextDecoder().decode(decryptedBuffer);
        } catch (error) {
            console.error('Decryption failed:', error);
            return null;
        }
    };

    const fetchPlayerDetails = useCallback(
        async (user) => {
            if (!user) return {};
            try {
                const encryptedUsername = await encrypt(user);
                const response = await fetch(
                    `${apiJSONURL}?cmd=playerDetail&u=${encryptedUsername}`
                );
                if (!response.ok)
                    throw new Error('Failed to fetch player details.');
                const data = await response.json();
                setCustomUsername(data.customUsername || null);
                setPlayerDetails(data);
                // setPassword(data.password)
                // const encryptedData = data.password
                // const decryptedUsername = await decrypt(encryptedData, apiKeyURL)
                // console.log("Player Password:", decryptedUsername)

                // const decryptedPassword = await decrypt(data.password)

                // console.log("Decrypted Password:", decryptedPassword)
                return data;
            } catch (error) {
                console.error('Error fetching player details:', error);
                return {};
            }
        },
        [apiJSONURL]
    );

    const getDefaultDates = () => {
        const today = new Date();
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(today.getDate() - 7);
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        return { fd: formatDate(oneWeekAgo), td: formatDate(today) };
    };

    const fetchRequestTransactionReport = useCallback(
        async (user, fd = '', td = '', type = '', status = '') => {
            if (!user) return [];
            try {
                const response = await fetch(
                    `${apiJSONURL}?cmd=getRequestReport&u=${user}&fd=${fd}&td=${td}&type=${type}&status=${status}`
                );
                if (!response.ok)
                    throw new Error(
                        'Failed to fetch request transaction report.'
                    );
                const data = await response.json();
                let mappedData = [];
                if (Array.isArray(data)) {
                    mappedData = data.map((entry) =>
                        Array.isArray(entry)
                            ? parseTransactionArray(entry)
                            : entry
                    );
                } else if (typeof data === 'object' && data !== null) {
                    mappedData = Object.values(data).map((entry) =>
                        Array.isArray(entry)
                            ? parseTransactionArray(entry)
                            : entry
                    );
                }
                // Reverse the order so the latest data is first.
                return mappedData.reverse();
            } catch (error) {
                console.error(
                    'Error fetching request transaction report:',
                    error
                );
                return [];
            }
        },
        [apiJSONURL]
    );

    const fetchReportData = async (cmd, user, fd, td, apiJSONURL) => {
        const url = `${apiJSONURL}?cmd=${cmd}&u=${user}&fd=${fd}&td=${td}`;
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch ${cmd}.`);
        }
        return response.json();
    };

    const fetchGamingReport = useCallback(
        async (user, fd = '', td = '') => {
            if (!user) return [];
            if (!fd || !td) {
                const dates = getDefaultDates();
                fd = dates.fd;
                td = dates.td;
            }
            try {
                const data = await fetchReportData(
                    'getGamingReport',
                    user,
                    fd,
                    td,
                    apiJSONURL
                );
                let mappedData = [];
                if (data && typeof data === 'object' && !Array.isArray(data)) {
                    mappedData = Object.values(data).map((arr) => {
                        if (Array.isArray(arr) && arr.length >= 3) {
                            return {
                                turnover: arr[1] || '0',
                                winLoss: arr[2] || '0',
                            };
                        }
                        return { turnover: '0', winLoss: '0' };
                    });
                } else {
                    mappedData = data;
                }
                // Reverse the array so the latest entries come first.
                return mappedData.reverse();
            } catch (error) {
                console.error('Error fetching gaming report:', error);
                return [];
            }
        },
        [apiJSONURL]
    );

    const fetchGamingReportDetails = useCallback(
        async (user, fd = '', td = '') => {
            if (!user) return [];
            if (!fd || !td) {
                const dates = getDefaultDates();
                fd = dates.fd;
                td = dates.td;
            }
            try {
                const data = await fetchReportData(
                    'getGamingReportDetails',
                    user,
                    fd,
                    td,
                    apiJSONURL
                );
                let mappedData = Object.values(data).flatMap((entries) => {
                    if (!Array.isArray(entries)) return [];
                    return entries.map((item) => {
                        const [game, turnover, winloss] = item.split('#');
                        return {
                            Game: game || '',
                            Turnover: turnover || '0',
                            Winloss: winloss || '0',
                        };
                    });
                });
                // Reverse the array to display latest first.
                return mappedData.reverse();
            } catch (error) {
                console.error('Error fetching gaming report details:', error);
                return [];
            }
        },
        [apiJSONURL]
    );

    const fetchCreditReport = useCallback(
        async (user, fd = '', td = '') => {
            if (!user) return [];

            // fallback to defaults
            if (!fd || !td) {
                const dates = getDefaultDates();
                fd = dates.fd;
                td = dates.td;
            }

            const url = `${apiJSONURL}?cmd=getHistory&u=${encodeURIComponent(
                user
            )}&fd=${fd}&td=${td}`;
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(
                    `Failed to fetch credit report: ${response.status}`
                );
            }

            const data = await response.json();

            const rawItems = Object.values(data); // this is an array of arrays
            const statusMap = {
                0: 'Waiting for approval',
                1: 'Approved',
                2: 'Not approved',
                3: 'Cancelled',
                4: 'Transferred',
                5: 'Rejected',
            };

            const results = rawItems.map((item) => {
                const [
                    reportID,
                    reportDate,
                    reportFromUser,
                    reportToUser,
                    transferAmount,
                    statusCode,
                ] = item;

                return {
                    reportID: String(reportID),
                    reportDate,
                    reportFromUser,
                    reportToUser,
                    transferAmount: String(transferAmount),
                    statusCode, // ← include it here
                    reportStatus: statusMap[statusCode] || String(statusCode),
                };
            });

            return results.reverse();
        },
        [apiJSONURL]
    );

    const fetch230BetHistory = useCallback(
        async (user, fd = '', td = '') => {
            if (!user) return [];
            if (!fd || !td) {
                const dates = getDefaultDates();
                fd = dates.fd;
                td = dates.td;
            }

            try {
                const url = `${promoURL}?cmd=get230BetHistory&u=${user}&fd=${fd}&td=${td}`;
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error('Failed to fetch 230 Bet History.');
                }
                const data = await response.json();
                const results = Object.values(data).map((item) => {
                    const splitted = item.split('|');
                    const statusMap = {
                        0: 'Success',
                        2: 'Invalid',
                        '-1': 'Cancelled',
                    };
                    const betStatus =
                        statusMap[splitted[3]] || splitted[3] || '';
                    return {
                        betTime: splitted[0] || '',
                        transactionId: splitted[1] || '',
                        betAmount: splitted[2] || '',
                        betStatus,
                        number1: splitted[4] || '',
                        number2: splitted[5] || '',
                    };
                });

                // Reverse the results so that the latest data appears first.
                return results.reverse();
            } catch (error) {
                console.error('Error fetching 230 Bet History:', error);
                return [];
            }
        },
        [promoURL]
    );

    const flattenReferralData = (data) => {
        const commissionKeys = Object.keys(data)
            .filter((key) => /^r\d+$/.test(key))
            .sort(
                (a, b) => parseInt(a.slice(1), 10) - parseInt(b.slice(1), 10)
            );
        const latestCommission = { dates: [], commissions: [] };
        commissionKeys.forEach((key) => {
            const value = data[key];
            if (Array.isArray(value) && value.length >= 2) {
                latestCommission.dates.push(value[0]);
                latestCommission.commissions.push(value[1]);
            }
        });
        const flattened = Object.entries(data).reduce((acc, [key, value]) => {
            if (/^r\d+$/.test(key)) {
                return acc;
            } else if (key === 'l') {
                if (Array.isArray(value)) {
                    acc.l = { players: value };
                } else if (typeof value === 'string') {
                    const matches = value.match(/ANOBA\d+/g);
                    acc.l = {
                        player: matches && matches.length ? matches[0] : value,
                    };
                } else {
                    acc.l = value;
                }
            } else {
                acc[key] = value;
            }
            return acc;
        }, {});

        flattened.latestCommission = latestCommission;
        return flattened;
    };

    const fetchReferralDetails = useCallback(
        async (user) => {
            if (!user) return {};
            try {
                const url = `${apiJSONURL}?cmd=getReferralDetails&u=${user}`;
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error('Failed to fetch referral details.');
                }
                const data = await response.json();
                return flattenReferralData(data);
            } catch (error) {
                console.error('Error fetching referral details:', error);
                return {};
            }
        },
        [apiJSONURL]
    );

    const updateUserData = useCallback(
        async (user) => {
            if (!user) return;
            setUserLoading(true);
            // const { balance, sg8, asc, goldenf, sbsbo } =
            //   await fetchWalletBalance(user)
            const { balance, sg8, asc, goldenf, sbsbo } =
                await fetchWalletBalance(user);
            setWalletBalance(balance);
            setSg8Wallet(sg8);
            setAscWallet(asc);
            setGoldenfWallet(goldenf);
            setSbsboWallet(sbsbo);
            const vip = await fetchVipDetails(user);
            // let player = {}
            // const path = window.location.pathname
            // if (
            //   path === "/profile" ||
            //   path === "/" ||
            //   path === "/slots/" ||
            //   path === "/live-casino" ||
            //   path === "/promotion"
            // ) {
            //   player = await fetchPlayerDetails(user)
            // }
            const player = await fetchPlayerDetails(user);

            setWalletBalance(balance);
            setSg8Wallet(sg8);
            setVipDetails(vip);
            setPlayerDetails(player);
            setUserLoading(false);
        },
        [fetchWalletBalance, fetchVipDetails, fetchPlayerDetails]
    );

    const filterTransactions = async (fd, td, type = '', status = '') => {
        if (!username) return;
        setUserLoading(true);

        if (!fd || !td) {
            const dates = getDefaultDates();
            fd = dates.fd;
            td = dates.td;
        }

        let queryType;
        if (type === 'all') {
            queryType = -1;
        } else if (type === 'deposit') {
            queryType = 0;
        } else if (type === 'withdrawal') {
            queryType = 1;
        } else {
            queryType = '';
        }

        let queryStatus;
        if (status === 'all') {
            queryStatus = -2;
        } else if (status === 'pending') {
            queryStatus = -1;
        } else if (status === 'failed') {
            queryStatus = 0;
        } else if (status === 'success') {
            queryStatus = 1;
        } else if (status === 'success confirmed') {
            queryStatus = 4;
        } else if (status === 'success & transfered') {
            queryStatus = 5;
        } else {
            queryStatus = '';
        }

        const transaction = await fetchRequestTransactionReport(
            username,
            fd,
            td,
            queryType,
            queryStatus
        );
        setTransactionReport(transaction);
        setUserLoading(false);
    };

    useEffect(() => {
        const storedUsernameEncrypted = localStorage.getItem('username');
        if (storedUsernameEncrypted) {
            const decryptedUsername = decryptUsername(storedUsernameEncrypted);
            setUsername(decryptedUsername);
            updateUserData(decryptedUsername);
        }
    }, [updateUserData]);

    /* ================= Game Data State ================= */
    const [allGamesFlat, setAllGamesFlat] = useState([]);
    const [gamesCountByProvider, setGamesCountByProvider] = useState({});
    const [gamesLoading, setGamesLoading] = useState(true);
    const [topGamesRtpMap, setTopGamesRtpMap] = useState({});
    const [rtpLoading, setRtpLoading] = useState(false);
    const [rtpError, setRtpError] = useState('');
    const rtpRequestRef = useRef(null);
    const rtpLastFetchedRef = useRef(0);
    const RTP_CACHE_DURATION = 5 * 60 * 1000;
    const [isTestMode, setIsTestMode] = useState(null);

    const fetchTopGamesRtp = useCallback(async (force = false) => {
        const now = Date.now();

        if (rtpRequestRef.current) {
            return rtpRequestRef.current;
        }

        if (
            !force &&
            rtpLastFetchedRef.current > 0 &&
            now - rtpLastFetchedRef.current < RTP_CACHE_DURATION
        ) {
            return;
        }

        const promoApiUrl = process.env.REACT_APP_API_JSON_URL_PROMO;

        if (!promoApiUrl) {
            setRtpError('RTP API URL is not configured.');
            return;
        }

        const providerMap = {
            pp: 'PRAGMATIC',
            jili: 'JILI',
            fachai: 'FACHAI',
            cq9: 'CQ9',
            bng: 'BNG',
            pgsoft: 'PGSOFT',
            rtg: 'RTG',
            jdb: 'JDB',
        };

        const normalizeGameName = (value = '') =>
            String(value)
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9]/g, '');

        setRtpLoading(true);
        setRtpError('');

        const request = (async () => {
            try {
                const url = new URL(promoApiUrl, window.location.origin);

                url.searchParams.set('cmd', 'getTopGamesRTP');
                url.searchParams.set('p', 'all');

                const response = await fetch(url.toString());

                if (!response.ok) {
                    throw new Error(`RTP API returned ${response.status}`);
                }

                const data = await response.json();

                if (!data || typeof data !== 'object' || Array.isArray(data)) {
                    throw new Error('Invalid RTP API response');
                }

                const rtpMap = {};

                Object.entries(data).forEach(([providerKey, games]) => {
                    const apiProvider = providerMap[providerKey.toLowerCase()];

                    if (!apiProvider || !games) return;

                    Object.values(games).forEach((value) => {
                        if (typeof value !== 'string') return;

                        const separatorIndex = value.lastIndexOf('|');

                        if (separatorIndex === -1) return;

                        const gameName = value.slice(0, separatorIndex).trim();
                        const rtp = value.slice(separatorIndex + 1).trim();

                        if (!gameName || !rtp) return;

                        const formattedRtp = rtp.includes('%')
                            ? rtp
                            : `${rtp}%`;

                        rtpMap[
                            `${apiProvider}:${normalizeGameName(gameName)}`
                        ] = formattedRtp;
                    });
                });

                setTopGamesRtpMap(rtpMap);
                rtpLastFetchedRef.current = Date.now();

                return rtpMap;
            } catch (error) {
                console.error('Failed to fetch Top Games RTP:', error);
                setRtpError('Unable to load RTP games.');
                return null;
            } finally {
                setRtpLoading(false);
            }
        })();

        rtpRequestRef.current = request;

        try {
            return await request;
        } finally {
            if (rtpRequestRef.current === request) {
                rtpRequestRef.current = null;
            }
        }
    }, []);

    useEffect(() => {
        const host = window.location.hostname;

        if (host === 'fgh.fun') {
            setIsTestMode(false);
        } else if (
            host === 'new.fgh.fun' ||
            host === 'new.fgh.cool' ||
            host === 'new.thefgh.fun'
        ) {
            setIsTestMode(true);
        } else {
            setIsTestMode(false);
        }
    }, []);

    const limit = 12;
    const tokenUrl = process.env.REACT_APP_TOKEN_URL;
    const launchUrl = process.env.REACT_APP_HTTPS_LAUNCH_URL;

    useEffect(() => {
        if (isTestMode === null) return;

        const fetchGames = async () => {
            try {
                const response = await fetch(
                    `${apiUrlNew}?cmd=getSlots&domain=fgh&isTest=${isTestMode}`
                );
                const data = await response.json();
                const flattenedGames = Object.entries(data).flatMap(
                    ([provider, firstMap]) =>
                        firstMap.flatMap((secondMap) =>
                            Object.entries(secondMap || {}).flatMap(
                                ([_, thirdMap]) =>
                                    Object.entries(thirdMap || {}).map(
                                        ([gameId, gameData]) => {
                                            const topGamesValue = String(
                                                gameData[4] || ''
                                            ).toLowerCase();

                                            return {
                                                provider,
                                                gameId,
                                                gameName: gameData[1] || '',
                                                gameCategory: gameData[3] || '',
                                                isTopGame:
                                                    topGamesValue === 'top' ||
                                                    topGamesValue === 'topnew',
                                                isNewGame:
                                                    topGamesValue === 'new' ||
                                                    topGamesValue === 'topnew',
                                                topGames: topGamesValue,
                                            };
                                        }
                                    )
                            )
                        )
                );
                const sortedGames = flattenedGames.sort((a, b) =>
                    a.gameName.localeCompare(b.gameName)
                );
                setAllGamesFlat(sortedGames);
                const counts = sortedGames.reduce((acc, game) => {
                    acc[game.provider] = (acc[game.provider] || 0) + 1;
                    return acc;
                }, {});
                setGamesCountByProvider(counts);
            } catch (error) {
                console.error('Error fetching games data:', error);
            } finally {
                setGamesLoading(false);
            }
        };

        fetchGames();
    }, [apiUrlNew, isTestMode]);

    // New useEffect to fetch rollover data
    useEffect(() => {
        const getRollover = async () => {
            try {
                const encryptedUsername = await encrypt(username);

                const response = await fetch(apiJSONURL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: `cmd=getRemainingRollover&u=${encryptedUsername}`,
                });
                const responseText = await response.text();
                const data = JSON.parse(responseText);

                if (data) {
                    setRollover(data);
                }
            } catch (error) {
                console.error('Error fetching remaining rollover:', error);
            }
        };

        if (username) {
            getRollover();
        }
    }, [username, apiJSONURL]);

    useEffect(() => {
        if (!username) return;

        const checkMysteryFriday = async () => {
            try {
                const encryptedUsername = await encrypt(username);
                const response = await fetch(apiJSONURL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: `cmd=mysteryFridayWinner&u=${encodeURIComponent(encryptedUsername)}`,
                });

                // API returned 404, 500, etc.
                if (!response.ok) {
                    setShowMysteryFridayBtn(false);
                    return;
                }

                const text = await response.text();

                // Empty response
                if (!text) {
                    setShowMysteryFridayBtn(false);
                    return;
                }

                const data = JSON.parse(text);

                if (data.awardedFlag === 0) {
                    setShowMysteryFridayBtn(true);
                } else {
                    // awardedFlag === 1 or any unexpected value
                    setShowMysteryFridayBtn(false);
                }
            } catch (error) {
                console.error('Error checking Mystery Friday status:', error);
                setShowMysteryFridayBtn(false);
            }
        };

        checkMysteryFriday();
    }, [username, apiJSONURL]);

    const extractMessages = (payload) => {
        if (!payload) return [];
        if (Array.isArray(payload)) {
            if (
                payload.length === 1 &&
                payload[0] &&
                typeof payload[0] === 'object' &&
                !Array.isArray(payload[0])
            ) {
                return Object.values(payload[0]);
            }
            return payload.flatMap((item) =>
                item && typeof item === 'object' && !Array.isArray(item)
                    ? 'messageId' in item
                        ? [item]
                        : Object.values(item)
                    : []
            );
        }
        if (typeof payload === 'object') return Object.values(payload);
        return [];
    };

    useEffect(() => {
        if (!isLoggedIn || !messageReload) return;

        const getMessages = async () => {
            try {
                const storedUsernameEncrypted =
                    localStorage.getItem('username');
                const decryptedUsername = decryptUsername(
                    storedUsernameEncrypted
                );

                const encryptedUsername = await encrypt(decryptedUsername);

                const [respUser, respAll] = await Promise.all([
                    fetch(promoURL, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams({
                            cmd: 'getMessage',
                            u: encryptedUsername,
                        }).toString(),
                    }),
                    fetch(promoURL, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams({
                            cmd: 'getMessageForAll',
                        }).toString(),
                    }),
                ]);

                const allMsgs = extractMessages(await respAll.json()).map(
                    (m) => ({
                        ...m,
                        To: m?.To ?? 'ALL',
                        type: 'all',
                    })
                );

                const userMsgs = extractMessages(await respUser.json()).map(
                    (m) => ({
                        ...m,
                        type: 'user',
                    })
                );

                const allMsgsWithConst = [...allMsgs];
                // console.log(allMsgsWithConst)
                const byPriorityAndTimeDesc = (a, b) => {
                    if (a.To === 'ALL' && b.To !== 'ALL') return -1;
                    if (a.To !== 'ALL' && b.To === 'ALL') return 1;
                    // Then sort by timestamp descending
                    return (
                        new Date(b.timestamp || b.createdAt) -
                        new Date(a.timestamp || a.createdAt)
                    );
                };

                setMessages(
                    [...userMsgs, ...allMsgsWithConst].sort(
                        byPriorityAndTimeDesc
                    )
                );
            } catch (err) {
                console.error('Error fetching messages:', err);
            } finally {
                setMessageReload(false);
            }
        };

        getMessages();
    }, [messageReload, isLoggedIn]);

    const markMessageAsRead = async (messageId) => {
        try {
            await fetch(promoURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    cmd: 'readMessage',
                    messageId,
                }).toString(),
            });

            setMessages((prev) =>
                prev.map((msg) =>
                    msg.messageId === messageId ? { ...msg, status: 1 } : msg
                )
            );
        } catch (error) {
            console.error('Error marking message as read:', error);
        }
    };

    //Ring the bell notification if detects status = 0 / on api
    const unreadCount =
        messages?.filter((msg) => Number(msg?.status) === 0).length ?? 0;

    const hasUnread = unreadCount > 0;

    return (
        <GlobalContext.Provider
            value={{
                showPrompt,
                setShowPrompt,
                showRecoveryBonusPrompt,
                setShowRecoveryBonusPrompt,
                message,
                loading: loadingBalance,
                handleReturnWallet,
                triggerFetch,
                username,
                customUsername,
                walletBalance,
                password,
                vipDetails,
                playerDetails,
                transactionReport,
                userLoading,
                rollover,
                showEasterEgg,
                setShowEasterEgg,
                updateUserData,
                refreshWalletBalances,
                applyWalletBalances,
                sg8Wallet,
                ascWallet,
                goldenfWallet,
                sbsboWallet,
                rtgWallet,
                setUsername,
                filterTransactions,
                fetchGamingReport,
                fetchGamingReportDetails,
                fetchPlayerDetails,
                fetch230BetHistory,
                fetchCreditReport,
                fetchReferralDetails,
                allGamesFlat,
                gamesCountByProvider,
                gamesLoading,
                limit,
                tokenUrl,
                launchUrl,
                liveGames: LiveGames,
                showMysteryFridayBtn,
                setShowMysteryFridayBtn,
                ag,
                setAg,
                goBack,
                messages,
                markMessageAsRead,
                hasUnread,
                unreadCount,
                currentJiliStage,
                setCurrentJiliStage,
                updateCurrentJiliStage,
                isLoggedIn,
                setIsLoggedIn,

                jiliFortuneRushInfo,
                jiliFortuneRushLoading,
                fetchJiliFortuneRushInfo,
                currentWeek: jiliFortuneRushInfo?.currentWeek ?? 0,
                // JILI Fortune Rush Leaderboard
                jiliFortuneRushLeaderboard,
                jiliFortuneRushMinimumTurnover,
                jiliFortuneRushWeek,
                jiliFortuneRushLeaderboardLoading,
                jiliFortuneRushLeaderboardError,
                getJiliFortuneRushLeaderboard,
                topGamesRtpMap,
                rtpLoading,
                rtpError,
                fetchTopGamesRtp,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};

export const useGlobalContext = () => useContext(GlobalContext);
